import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Nullable } from "config";
import { RootState } from "store";
import {
  IOriginationSourcesPaginatedResponse,
  getOriginationSourcesPaginated,
} from "api";

import { OriginationSourceModalModes } from "./enums";
import { IOriginationSourceModalData } from "./types";

const originationSourceName = "origination-source";

const initialState = {
  originationSourcesData: null as Nullable<
    IOriginationSourcesPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: OriginationSourceModalModes.VIEW,
  } as IOriginationSourceModalData,
};

export const fetchOriginationSources = createAsyncThunk(
  `${originationSourceName}/fetchOriginationSources`,
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }
    const response = await getOriginationSourcesPaginated(filters);
    return response;
  }
);

const originationSourceSlice = createSlice({
  name: originationSourceName,
  initialState,
  reducers: {
    setOriginationSourceModalData: (
      state,
      action: PayloadAction<IOriginationSourceModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeOriginationSourceModal: (state) => {
      state.modalData = initialState.modalData;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchOriginationSources.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        originationSourcesData: action.payload?.edges ?? null,
        totalCount: action.payload?.totalCount ?? 1,
      };
    });
    builder.addCase(fetchOriginationSources.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const { setOriginationSourceModalData, closeOriginationSourceModal } =
  originationSourceSlice.actions;

export default originationSourceSlice.reducer;
